module.exports = __webpack_public_path__ + "static/media/Insta-Fill.48f4f1e1.svg";